<template>
    <div class="pageContent">
        <div class="pageContent-in">
            <main class="pageContent-main">
                <div class="textcontent">
                    <calculation-headline/>
                    <div class="steps steps--calculator">
                        <button v-on:click="goTo(1)" :class="{'steps__item': true, 'steps__item--prev': [2,3].indexOf(getStep()) !== -1, 'steps__item--current': getStep() === 1}">
                            1.
                        </button>
                        <button v-on:click="goTo(2)" :class="{'steps__item': true, 'steps__item--prev': [3].indexOf(getStep()) !== -1, 'steps__item--current': getStep() === 2}">
                            2.
                        </button>
                        <button v-on:click="goTo(3)" :class="{'steps__item': true, 'steps__item--next': [2,3].indexOf(getStep()) !== -1, 'steps__item--current': getStep() === 3}">
                            3.
                        </button>
                    </div>
                    <p v-if="getStep() === 1">Vypočtěte si snadno ve 3 krocích kolik budete potřebovat materiálu na
                        svůj projekt.</p>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import CalculationHeadline from './Headline';

    export default {
        name: 'CalculationSteps',
        components: {
            CalculationHeadline
        },
        methods: {
            getStep() {
                const {projectSlug, constructionId} = this.$route.params;
                if (projectSlug && constructionId) {
                    return 3;
                } else if (projectSlug) {
                    return 2;
                }
                return 1;
            },
            goTo(toStep) {
                const currentStep = this.getStep();

                if (toStep < currentStep) {
                    if (toStep === 1) {
                        this.$router.push({ name: 'calculation.projectSelect' })
                    } else if (toStep === 2) {
                        const { projectSlug } = this.$route.params;
                        this.$router.push({
                            name:   'calculation.constructionSelect',
                            params: { projectSlug: projectSlug }
                        })
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/steps/Steps.vue